import React from 'react';
import {Maybe} from 'monet';
import * as R from 'ramda';

import LapsedSurrender from '@/b2b/pages/Report/ExtendForms/LapsedSurrender';
import NewClient from '@/b2b/pages/Report/ExtendForms/NewClient';
import NewBusinessStatus from '@/b2b/pages/Report/ExtendForms/NewBusinessStatus';
import SalesPerformance from '@/b2b/pages/Report/ExtendForms/SalesPerformance';
import TransferIn from '@/b2b/pages/Report/ExtendForms/TransferIn';
import ClientBirthday from '@/b2b/pages/Report/ExtendForms/ClientBirthday';
import MissingPremium from '@/b2b/pages/Report/ExtendForms/MissingPremium';
import CreditCardExpiry from '@/b2b/pages/Report/ExtendForms/CreditCardExpiry';
import ClientPortfolio from '@/b2b/pages/Report/ExtendForms/ClientPortfolio';
import PolicySummary from '@/b2b/pages/Report/ExtendForms/PolicySummary';
import PolicyItemDetails from '@/b2b/pages/Report/ExtendForms/PolicyItemDetails';
import PolicyOwner from '@/b2b/pages/Report/ExtendForms/PolicyOwner';
import PolicyAbBv from '@/b2b/pages/Report/ExtendForms/PolicyAbBv';
import PersonalAbBv from '@/b2b/pages/Report/ExtendForms/PersonalAbBv';
import TrainingHistory from '@/b2b/pages/Report/ExtendForms/TrainingHistory';

const extendFormList = R.cond([
  [
    R.equals('afs'),
    R.always({
      '1': LapsedSurrender,
      '2': NewClient,
      '3': NewBusinessStatus,
      '4': SalesPerformance,
      '5': TransferIn,
      '6': ClientBirthday,
      '7': MissingPremium,
      '8': CreditCardExpiry,
      '9': ClientPortfolio,
      '10': PolicySummary,
      '11': PolicyItemDetails,
      '12': PolicyOwner,
      '13': PolicyAbBv,
      '14': PersonalAbBv,
      '201': TrainingHistory,
    }),
  ],
  [
    R.equals('ipc'),
    R.always({
      '1': PolicySummary,
      '2': PolicyItemDetails,
      '3': PolicyOwner,
      '4': SalesPerformance,
      '5': ClientBirthday,
    }),
  ],
  [
    R.equals('absg'),
    R.always({
      '1': PolicySummary,
      '2': PolicyItemDetails,
    }),
  ],
]);
const ExtendForms = props => {
  const ExtendFormMappedForm = extendFormList(props.siteCode)[props.reportType];

  return Maybe.fromFalsy(ExtendFormMappedForm)
    .map(() => <ExtendFormMappedForm />)
    .orNull();
};

export default ExtendForms;
